var { cELM, debounce, Wrap4Arrow, isMobile } = require("../../utils");
var Chat = require("../../chat");
var Scroller = require("../scroller");
const sanitizer = require('../../utils/sanitizer');

class AutoCompleteInputInsurance {
  constructor(data) {
    this.data = data;
    this.element = cELM("div", "option-block autocomplete");

    this.validateMinLength = parseInt(((data || {}).searchValidation || {}).minInputLength);

    if(Number.isNaN(this.validateMinLength)) {
        this.validateMinLength = false;
    }

    if (data.mode) {
      this.mode = data.mode;
      this.element.classList.add(data.mode);
      if (data.mode == "popup-autocomplete") {
        var textSpan = cELM("span", "")
        textSpan.addELM(cELM("span", "titletext", data.text));
        textSpan.addELM(cELM("span", "subtext", " " + data.subtext));
        this.text =  textSpan;
      }
    }

    this.__elements = null;
    this.page = 1;
    this.aggregateValues = [];
    this.searchCount = 0; //previous count of aggregateValues
    this.createElement();
  }

  getELM() {
    return this.element;
  }

  getHTML() {
    return this.element;
  }

  createElement() {
    var _self = this;
    var inputContainer = cELM("div", "inputs-wrapper");
    var searchBlock = cELM("div", "search-block");
    var moreWrapper = cELM("div", "more-wrapper");
    var defaultText = _self.data && _self.data.values ? _self.data.values.trim() : '';
    var inputEl = cELM("input", "text-input search-input");
    inputEl.value = defaultText;

    inputEl.placeholder = getLngTxt("input.placeholder.type");
    inputEl.setAttribute('spellcheck', 'false');
    inputEl.setAttribute('autocomplete', 'off');
    inputEl.setAttribute('autocorrect', 'off');
    if (_self.data && _self.data.placeholder) {
      inputEl.placeholder = _self.data.placeholder;
    }

    var buttonEl = cELM("div", "go-button go-button-active", getLngTxt("button.submit"));

    if (_self.data && _self.data.button) {
      buttonEl.innerHTML = _self.data.button;
    }
    var handleKeyUp = function(event) {
      _self.aggregateValues = [];
      _self.page = 1;
      _self.clearScreen()
      search(event.target.value);
    };

    var hideArrow = () => {
      var arrow = _self.__elements.arrow;
      if (arrow) {
        arrow.classList.remove('arrow-active');
      }
    };

    var showArrow = () => {
      var arrow = _self.__elements.arrow;
      if (arrow) {
        arrow.classList.add('arrow-active');
      }
    };

    var search = (value) => {
      if(_self.validateMinLength && (inputEl.value || '').trim().length < _self.validateMinLength) {
        searchBlock.classList.remove("search-block-active");
        buttonEl.classList.remove('go-button-active');
        showArrow();
        _self.text.style.display = 'block';
        if (_self.__elements.subtext) {
          _self.__elements.subtext.style.display = 'none'
        }

        return;
      }

      hideArrow();
      buttonEl.classList.add('go-button-active');

      if (_self.mode == "popup-autocomplete") {
        _self.updateSuggestions(null, { showSpinner: true });
        _self.text.style.display = "none";
        if (_self.__elements.subtext) {
          _self.__elements.subtext.style.display = 'block'
        }

        _self.lastSearchTimestamp = Date.now();
        Chat.default.send(
          {
            typing: inputEl.value.toUpperCase(),
            reference: {
              id: _self.data.id,
            },
            requestTimestamp: _self.lastSearchTimestamp,
            offset: (_self.page - 1)
          },
          null,
          _self.element,
        );
      } else {
        const sanitizedValue = sanitizer.sanitizeString(value || '');

        if (window.__FN_DATA_WRAPPER) {
          Chat.default.send(window.__FN_DATA_WRAPPER(sanitizedValue), null, _self.element);
        } else {
          Chat.default.send(
            {
              typing: sanitizedValue.toUpperCase(),
              reference: {
                id: _self.data.id,
              },
            },
            null,
            _self.element,
          );
        }
      }
    }

    this.search = search;

    inputEl.onkeyup = debounce(handleKeyUp, 200);

    buttonEl.onclick = function(evt) {
      _self.aggregateValues = [];
      _self.page = 1;
      _self.clearScreen()
      if(_self.validateMinLength && (inputEl.value || '').trim().length < _self.validateMinLength) {
        return;
      }

      inputEl.blur();

      if (_self.mode == "popup-autocomplete") {
        _self.updateSuggestions(null, { showSpinner: true });
        _self.text.style.display = "none";
        _self.lastSearchTimestamp = Date.now();
        Chat.default.send(
          {
            typing: inputEl.value.toUpperCase(),
            reference: {
              id: _self.data.id,
            },
            requestTimestamp: _self.lastSearchTimestamp,
            offset: (_self.page - 1)
          },
          null,
          _self.element,
        );

      } else {
        Chat.default.send(inputEl.value, null, _self.element);
      }
    };
    var arrow = Wrap4Arrow(inputEl, true);
    inputContainer.addELM(arrow);

    if (!isMobile()) {
         inputContainer.addELM(buttonEl);
    }

    if (_self.mode == "popup-autocomplete")
    {

      this.element.addELM(inputContainer);
      this.element.addELM(searchBlock);

    }
    else
    {
      this.element.addELM(searchBlock);
      this.element.addELM(inputContainer);
    }

    if (this.text) {
      this.element.addELM(this.text);
    }

    this.__elements = {
      inputEl,
      searchBlock,
      buttonEl,
      inputContainer,
      arrow,
      moreWrapper
    };

    if(_self.mode == "popup-autocomplete") {
      //add cancel button
      var cancelBtn = cELM("div", "button-cancel", this.data.cancelText);
      cancelBtn.onclick = function(evt) {
        _self.element.style.display = 'none';
        searchBlock.classList.remove("search-block-active");
        buttonEl.classList.add("go-button-active");
        inputContainer.classList.add('search-hidden');
        _self.text.style.display = 'none';
        _self.__elements.subtext.style.display = 'none';

        if(cancelBtn) {
          cancelBtn.classList.add('search-hidden')
        }

        Chat.default.send({action: 'cancelSearch' });
      };

      // Add search subtext
      if (_self.data && _self.data.searchSubtext) {
        var subTextElement = cELM("div", "subtext", _self.data.searchSubtext);
        this.element.addELM(subTextElement);
        this.__elements.subtext = subTextElement;
      }

      var rowBtn = cELM('div', 'row row-buttons row-autocomplete');
      rowBtn.addELM(cancelBtn);
      this.element.addELM(rowBtn);

      this.__elements.cancelBtn = cancelBtn;
    }
    
    // Search initial text
    search(defaultText);

    return this.element;
  }

  addSpinner(values, params) {
    var { searchBlock } = this.__elements;
    var _self = this;
    if(params && params.showSpinner) {//} && (!values || values.length === 0)) {
      var html = `<div class="autocomplete-thinking${params.more ? '-more': ''}">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>`;

      _self._spinner = true;

      var _el = cELM("div", "search-loading", html);
      searchBlock.addELM(_el);

      if(_self.text && _self.text.style) {
        _self.text.style.display = 'none';
      }
    }
  }

  addKeepTyping() {
    var { searchBlock } = this.__elements;
    var _self = this;

    var keepTypingText = this.data.keepTypingText || 'Keep typing to Search';

    var _el = cELM("div", "search-keep-typing", keepTypingText);
    searchBlock.addELM(_el);
  }

  updateSuggestions(data, params) {
    var _self = this;
    if (data) {
      // Ignore results from previous searches or if the input has less than the minimum search term length
      var isTheLastRequest = data.requestTimestamp === _self.lastSearchTimestamp;
      var input = _self.__elements.inputEl;
      var isInputTooShort = _self.validateMinLength && input && (input.value || '').trim().length < _self.validateMinLength;
      if (!isTheLastRequest || isInputTooShort) {
        return;
      }
    }

    var values = data ? data.suggestions : null;
    var { searchBlock, inputEl, buttonEl, inputContainer, cancelBtn } = this.__elements;

    const sanitizedValue = sanitizer.sanitizeString((inputEl || {}).value || '');

    inputContainer.classList.remove('search-hidden');
/*
    let child = searchBlock.lastElementChild;
    while (child) {
      searchBlock.removeChild(child);
      child = searchBlock.lastElementChild;
    } */

    if (!values || values.length <= 2) {
      searchBlock.classList.add("less-sugg");
    } else {
      searchBlock.classList.remove("less-sugg");
    }

    if (params && !params.showSpinner && params.showLoading && !values) {
      var _el = cELM("div", "search-loading", "Searching");
      searchBlock.addELM(_el);
    }

    if ((!values || values.length === 0) && _self.mode != "popup-autocomplete") {
      console.log('Will add spinner');
      var _el = cELM("div", "search-item", sanitizedValue);
      _el.onclick = function() {
        searchBlock.classList.remove("search-block-active");
        buttonEl.classList.add("go-button-active");
        inputContainer.classList.add('search-hidden');
        if(cancelBtn) {
          cancelBtn.classList.add('search-hidden')
        }

        if (_self.__elements.subtext) {
          _self.__elements.subtext.style.display = 'none'
        }

        Chat.default.send(sanitizedValue, null, _self.element);

      };
      searchBlock.addELM(_el);
    } else if (_self.mode == "popup-autocomplete" && values && values.length === 0) {
      this.clearScreen();
      this.addKeepTyping();
      searchBlock.addELM(_el);
    } else if (values) {

      _self.clearScreen();

      if (_self.data && _self.data.instruction) {
        var _el = cELM("div", "search-instruction", _self.data.instruction);
        searchBlock.addELM(_el);
      }

      _self.searchCount = _self.aggregateValues.length;
      _self.aggregateValues = _self.aggregateValues.concat(values)

      _self.aggregateValues.map(si => {
        //var isDup = _self.isDuplicate(si, origList )
        //if (!isDup) {
        var _el = cELM("div", "search-item", si.name);
        _el.onclick = function() {
          inputEl.value = si.name || si.value;
          inputEl.blur();
          searchBlock.classList.remove("search-block-active");
          buttonEl.classList.add("go-button-active");
          inputContainer.classList.add('search-hidden');
          if(cancelBtn) {
            cancelBtn.classList.add('search-hidden')
          }

          if (_self.__elements.subtext) {
            _self.__elements.subtext.style.display = 'none';
          }

          var valueToSend = si.value || si.name;
          if (params && params.sendObject) {
            valueToSend = si;
          }

          Chat.default.send(valueToSend, null, _self.element);
        };
        searchBlock.addELM(_el);
        //}
      });

      searchBlock.addELM(_self.__elements.moreWrapper);

      if (values[0] && values[0].localSearch) { 
        _self.__elements.moreWrapper.style.display = 'block';
        if (!_self.__elements.moreWrapper.innerHTML) {
          var more = cELM("div", "btn-more", "More")
          more.innerHTML = 'Show More';
          _self.__elements.moreWrapper.addELM(more);
          more.onclick = _self.showMore.bind(_self);
        } 
      } else {
        _self.__elements.moreWrapper.style.display = 'none';
      }
    }

    if (params.showSpinner) {
      params.more = true
      this.addSpinner(values, params);
    }

    if(_self.mode != "popup-autocomplete") {
      if (!searchBlock.classList.contains("search-block-active")) {
        Scroller.smoothScrollTo(window.scrollY + 175);
      }
    }

    if(this.text && _self.mode == "popup-autocomplete"){
      if(!values){
        //this.text.style.display = 'block';  
      }
      else
      {
        this.text.style.display = 'none';   
      }
     
    }

    searchBlock.classList.add("search-block-active");
  }

  reset() {
    if (!this.__elements) return;
    this.__elements.inputEl.value = "";

    if(this.text && this.mode == "popup-autocomplete"){
       this.text.style.display = 'block';
    }
    
    var { searchBlock, inputEl, buttonEl, inputContainer } = this.__elements;
    var _self = this;
    inputContainer.classList.remove('search-hidden');
    var child = searchBlock.lastElementChild;
    while (child) {
      searchBlock.removeChild(child);
      child = searchBlock.lastElementChild;
    }    
  }

  showMore(e) {
    e.preventDefault();
    var parent = e.target.parentNode;
    parent.innerHTML = '';
    this.page += 1;
    this.search();
  }

  scrollToNewResults() {
    var searchInstructionEl = document.getElementsByClassName('search-instruction')[0]

    if (searchInstructionEl) { //margins
      var searchInstruction = (searchInstructionEl || {}).offsetHeight || 0;
      var searchInstructionStyle =   searchInstruction.currentStyle || window.getComputedStyle(searchInstructionEl)
      if (searchInstructionStyle)
        searchInstruction += (parseInt(searchInstructionStyle.marginTop)|| 0) + (parseInt(searchInstructionStyle.marginBottom)|| 0) 
    }
    var searchItemEl = document.getElementsByClassName('search-item')[0];
    if (searchItemEl) { //margins
      var searchItem = (searchItemEl || {}).offsetHeight || 0;
      var searchItemStyle =   searchItem.currentStyle || window.getComputedStyle(searchItemEl)
      if(searchItemStyle)
        searchItem += (parseInt(searchItemStyle.marginTop)|| 0) + (parseInt(searchItemStyle.marginBottom)|| 0) 
    }
    this.__elements.searchBlock.scrollTop = searchInstruction+(this.searchCount* searchItem);
  }

  clearScreen() {
    var child = this.__elements.searchBlock.lastElementChild;
    while (child) {
      this.__elements.searchBlock.removeChild(child);
      child = this.__elements.searchBlock.lastElementChild;
    } 
  }

  focus() {
    if (!this.__elements) return;
    // this.__elements.inputEl.focus();
  }
}

module.exports = AutoCompleteInputInsurance;
